/// frontend/src/components/Logo.js
import React from 'react';

const logos = {
  "Castle Creek": "https://rentyakima.com/images/logos/castle-creek.webp",
  "University Parkway": "https://rentyakima.com/images/logos/university-parkway.webp",
  "Lake Aspen": "https://rentyakima.com/images/logos/lake-aspen.webp",
  "The Lodges": "https://rentyakima.com/images/logos/the-lodges.webp",
  "Powerhouse Flats": "https://rentyakima.com/images/logos/powerhouse-flats.webp"
};

const Logo = ({ apartment }) => {
  const logoUrl = logos[apartment];
  return (
    logoUrl ? (
      <img
        src={logoUrl}
        alt={`${apartment} Logo`}
        className="w-full h-full object-contain mb-4"
        style={{ maxWidth: '200px', maxHeight: '200px' }}
      />
    ) : null
  );
};

export default Logo;
